import { useQuery } from '@tanstack/react-query';

import { useRequest } from '@frontend/api';
import type { QueryFunction } from '@frontend/api';

import { FinalizeQuoteSettings } from './types';

export type UseFinalizeQuoteSettingsParams = {
  groupId: string;
};

export type FinalizeQuoteSettingsKey = readonly [
  'suppliers',
  string,
  'finalizeQuoteSettings',
];

export const getFinalizeQuoteSettingsKey = (
  params: UseFinalizeQuoteSettingsParams,
): FinalizeQuoteSettingsKey =>
  ['suppliers', params.groupId, 'finalizeQuoteSettings'] as const;

export const useFinalizeQuoteSettings: QueryFunction<
  FinalizeQuoteSettings,
  [UseFinalizeQuoteSettingsParams],
  FinalizeQuoteSettingsKey
> = (params, { requestOptions, queryOptions } = {}) => {
  const queryKey = getFinalizeQuoteSettingsKey(params);
  const request = useRequest(requestOptions);

  return useQuery({
    ...queryOptions,
    queryKey,
    queryFn: ({ signal }) =>
      request(`/suppliers/${params.groupId}/finalize_quote_settings`, {
        init: {
          method: 'GET',
          signal,
        },
      }),
  });
};
